import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from "vue";
import { useStore } from "@/composables/useTypedStore";
import InfoBanner from "@/components/Base/InfoBanner";


export default /*#__PURE__*/_defineComponent({
  __name: 'SocketDisconnectedHint',
  setup(__props) {

const store = useStore();

const isSocketDisconnected = computed(() => {
    return store.getters['app/isOnline'] && store.getters['app/isSocketDisconnected'];
});

return (_ctx: any,_cache: any) => {
  return (isSocketDisconnected.value)
    ? (_openBlock(), _createBlock(_unref(InfoBanner), {
        key: 0,
        type: 'warning'
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }))
    : _createCommentVNode("", true)
}
}

})